import { Component, OnInit,Input,Output,EventEmitter } from '@angular/core';
import { ApiService } from "../api.service";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
	selector: 'app-case-practice-head',
	templateUrl: './case-practice-head.component.html',
	styleUrls: ['./case-practice-head.component.css']
})
export class CasePracticeHeadComponent implements OnInit {

  @Output() closeClick = new EventEmitter < any > ();
  @Output() onReviewConversation = new EventEmitter < any > ();
  @Input() simulationName: string;// 情景模拟名称
  @Input() theme: any;
  @Input() progressTheme:string = "box";
  @Input() progress:number;

  stepList: any;

  constructor(private apiService: ApiService,
              private route: ActivatedRoute,
              private router: Router) {}

  ngOnInit() {
  }

  close($event){
    this.closeClick.emit();
    $event.stopPropagation();
  }

  reviewConversation(){
    this.onReviewConversation.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/case-practice-head/case-practice-head.component.ts